export const TEMPERATURE_DEGREES = /()(\*C)(?=\1)/;
export const REPLACED_SYMBOL = "*";

export const replaceCelsiusDegreeSymbols = (value: string): string => {
  const regex = new RegExp(TEMPERATURE_DEGREES);
  if (!value) {
    return "";
  }
  if (regex.test(value)) {
    return value.replace(REPLACED_SYMBOL, "°");
  } else {
    return value;
  }
};
